import { shape, string, number } from 'prop-types';

export default shape({
  _id: string.isRequired,
  confirmedAt: number.isRequired,
});
